import { render, staticRenderFns } from "./orderRemindManage.vue?vue&type=template&id=94783c88&scoped=true"
import script from "./orderRemindManage.vue?vue&type=script&lang=js"
export * from "./orderRemindManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94783c88",
  null
  
)

export default component.exports